<template>
	<div class="fav">
		<userMenu></userMenu>
		<div class="fav-wrap"></div>
	</div>
</template>

<script>
	import userMenu from '@/page/public/userMenu'
	import api from '@/api/api'
	export default {
		components: {
			userMenu: userMenu
		},
		data() {
			return {
			
			}
		}
	}	
</script>

<style>
	.fav-wrap{
		width: 100%;
		height: 100vh;
		background-color: var(--bg3);
	}
</style>



// WEBPACK FOOTER //
// src/page/favorite.vue